export class EnergyTypesFilter {
  name: string;
  energyTypes: Array<EnergyTypes>;
  isVisible: boolean;

  constructor(_name: string, _energyTpes: Array<EnergyTypes>, _isVisible: boolean) {
    this.name = _name;
    this.energyTypes = _energyTpes;
    this.isVisible = _isVisible;
  }

  isOn(): boolean {
    return this.energyTypes.every((x) => x.on);
  }
}

export interface EnergyTypes {
  name: string;
  icon: string;
  on: boolean;
  isVisible: boolean;
}

export const EnergyTypesGroupingByKeys = {
  Sparte: ['SLP|RLM', 'GAS'],
  Erzeuger: ['PV', 'BIO', 'WIND', 'POWER', 'HYDRO'],
  Verbraucher: ['HEAT', 'WATER'],
};
